import React, { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import axios from 'axios';
import Web3Modal from 'web3modal';
import NavigationHeader from './NavigationHeader';
import AppFooter from './Footer';
import { useTranslation } from 'react-i18next';
import {
  Panel,
  Row,
  Col,
  ButtonToolbar,
  Button,
  Radio,
  RadioGroup,
  Divider,
} from 'rsuite';
import { marketplaceAddress } from './config';
import KubondModal from './KubondModal';
import NFTMarketplace from './artifacts/contracts/NFTMarketplace.sol/NFTMarketplace.json';

import Analytics from '@aws-amplify/analytics';
import awsconfig from './aws-exports';
Analytics.configure(awsconfig);

export default function Kubonds() {
  const { t } = useTranslation();

  const sendAnalytics = async (value) => {
    Analytics.record({ name: 'buy', attributes: { kubond: value } }).then(
      (evt) => {
        console.log('Event Submitted' + JSON.stringify(evt));
      }
    );
  };

  const styles = {
    radioGroupLabel: {
      padding: '8px 12px',
      display: 'inline-block',
      verticalAlign: 'middle',
    },
  };
  const dummy_nfts = [
    {
      price: '$37.5',
      tokenId: 1,
      seller: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266',
      owner: '0x6A655aCBeDF26a708a0204Bdf3603C7c6a159417',
      image: '/AMC.png',
      name: 'AMCKB',
      maturity: '6/15/2025',
      monthly_payment: '$0.24',
      annual_payment: '$2.88',
      payments_left: 444,
      total_lifetime_payments: '$106',
      total_return_rate: '284%',
      description: 'test_kb',
    },
    {
      price: '$44.5',
      tokenId: 1,
      seller: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266',
      owner: '0x6A655aCBeDF26a708a0204Bdf3603C7c6a159417',
      image: '/AMZN.png',
      name: 'AMZNKB',
      maturity: '6/3/2060',
      monthly_payment: '$0.11',
      annual_payment: '$1.35',
      payments_left: 5484,
      total_lifetime_payments: '$617',
      total_return_rate: '1387%',
      description: 'test_kb',
    },
    {
      price: '$61.9',
      tokenId: 1,
      seller: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266',
      owner: '0x6A655aCBeDF26a708a0204Bdf3603C7c6a159417',
      image: '/Apple.png',
      name: 'APPLKB',
      maturity: '2/23/2046',
      monthly_payment: '$0.19',
      annual_payment: '$2.33',
      payments_left: 3432,
      total_lifetime_payments: '$665',
      total_return_rate: '1074%',
      description: 'test_kb',
    },
    {
      price: '$37.6',
      tokenId: 1,
      seller: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266',
      owner: '0x6A655aCBeDF26a708a0204Bdf3603C7c6a159417',
      image: '/BB&B.png',
      name: 'BB&BKB',
      maturity: '8/1/2024',
      monthly_payment: '$0.22',
      annual_payment: '$2.58',
      payments_left: 3204,
      total_lifetime_payments: '$690',
      total_return_rate: '1833%',
      description: 'test_kb',
    },
    {
      price: '$50.3',
      tokenId: 1,
      seller: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266',
      owner: '0x6A655aCBeDF26a708a0204Bdf3603C7c6a159417',
      image: '/Carnival.png',
      name: 'CARNIVALKB',
      maturity: '1/15/2028',
      monthly_payment: '$0.28',
      annual_payment: '$3.33',
      payments_left: 816,
      total_lifetime_payments: '$226',
      total_return_rate: '450%',
      description: 'test_kb',
    },
    {
      price: '$52.5',
      tokenId: 1,
      seller: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266',
      owner: '0x6A655aCBeDF26a708a0204Bdf3603C7c6a159417',
      image: '/GS.png',
      name: 'GOLDMANKB',
      maturity: '3/15/2035',
      monthly_payment: '$0.16',
      annual_payment: '$1.88',
      payments_left: 1848,
      total_lifetime_payments: '$289',
      total_return_rate: '551%',
      description: 'test_kb',
    },
    {
      price: '$52.5',
      tokenId: 1,
      seller: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266',
      owner: '0x6A655aCBeDF26a708a0204Bdf3603C7c6a159417',
      image: '/RA.png',
      name: 'RITEAIDKB',
      maturity: '2/15/2027',
      monthly_payment: '$0.32',
      annual_payment: '$3.85',
      payments_left: 684,
      total_lifetime_payments: '$219',
      total_return_rate: '500%',
      description: 'test_kb',
    },
  ];
  const [isAllKubonds, setIsAllKubonds] = React.useState(true);
  const [nfts, setNfts] = useState([]);
  const [backdrop, setBackdrop] = React.useState('static');
  useEffect(() => {
    loadAllNFTs();
  }, []);

  async function loadAllNFTs() {
    /* create a generic provider and query for unsold market items */
    //const provider = new ethers.providers.JsonRpcProvider();
    const provider = new ethers.providers.JsonRpcProvider(
      'https://rpc-mumbai.maticvigil.com'
    );
    const contract = new ethers.Contract(
      marketplaceAddress,
      NFTMarketplace.abi,
      provider
    );
    const data = await contract.fetchMarketItems();

    /*
     *  map over items returned from smart contract and format
     *  them as well as fetch their token metadata
     */
    const items = await Promise.all(
      data.map(async (i) => {
        const tokenUri = await contract.tokenURI(i.tokenId);
        const meta = await axios.get(tokenUri);
        let price = ethers.utils.formatUnits(i.price.toString(), 'ether');
        let item = {
          price,
          tokenId: i.tokenId.toNumber(),
          seller: i.seller,
          owner: i.owner,
          image: meta.data.image,
          name: meta.data.name,
          description: meta.data.description,
        };
        return item;
      })
    );
    setIsAllKubonds(true);
    let items_dup = [items[0], items[0], items[0], items[0]];
    console.log(items[0]);
    setNfts(items_dup);
    // setLoadingState('loaded');
  }

  async function loadMyNFTs() {
    try {
      const web3Modal = new Web3Modal({
        network: 'mainnet',
        cacheProvider: true,
      });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();

      const marketplaceContract = new ethers.Contract(
        marketplaceAddress,
        NFTMarketplace.abi,
        signer
      );
      const data = await marketplaceContract.fetchMyNFTs();

      const items = await Promise.all(
        data.map(async (i) => {
          const tokenURI = await marketplaceContract.tokenURI(i.tokenId);
          const meta = await axios.get(tokenURI);
          let price = ethers.utils.formatUnits(i.price.toString(), 'ether');
          let item = {
            price,
            tokenId: i.tokenId.toNumber(),
            seller: i.seller,
            owner: i.owner,
            image: meta.data.image,
            tokenURI,
          };
          return item;
        })
      );
      setIsAllKubonds(false);
      setNfts(items);
      // setLoadingState('loaded');
    } catch (err) {
      alert(err.toString());
    }
  }

  return (
    <>
      <NavigationHeader />
      <Panel style={{ margin: 20 }}>
        <div style={{ margin: 10 }}>
          <h3>Kubonds</h3>
          <RadioGroup
            name="radioList"
            appearance="picker"
            inline
            value={isAllKubonds}
            // onChange={(value) => setBackdrop(value)}
          >
            {/* <span style={styles.radioGroupLabel}>Drops: </span> */}
            <Radio onClick={() => loadAllNFTs()} value={isAllKubonds}>
              {t('kubonds.all')}
            </Radio>
            {/* <Radio onClick={() => loadMyNFTs()} value={!isAllKubonds}>
              {t('kubonds.purchased')}
            </Radio> */}
            <Radio
              onClick={() => alert(t('alert.purchased'))}
              value={!isAllKubonds}
            >
              {t('kubonds.purchased')}
            </Radio>
          </RadioGroup>
        </div>
        <Row>
          {dummy_nfts.map((nft, i) => (
            <Col md={6} sm={12}>
              <Panel
                shaded
                bordered
                bodyFill
                style={{ display: 'inline-block', width: 320, margin: 10 }}
              >
                <img src={nft.image} height="240" />
                <Panel>
                  {/* <p>
                    <small>{nft.description}</small>
                  </p> */}
                  <div style={{ textAlign: 'center' }}>
                    {nft.name}
                    <Divider vertical />
                    <b>Price:</b> {nft.price}
                    <Divider vertical />
                    <Button
                      onClick={() => {
                        sendAnalytics(nft.name);
                        alert(t('alert.buy'));
                      }}
                      size="sm"
                      appearance="primary"
                      value="dark"
                    >
                      {t('kubonds.buy')}
                    </Button>
                  </div>
                </Panel>
              </Panel>
            </Col>
          ))}
        </Row>
        {/* <KubondModal /> */}
      </Panel>
      <AppFooter />
    </>
  );
}
